export const tableHeaders = [
  { label: 'Id', value: 'superAdminUserId' },
  { label: 'Title', value: 'title' },
  // { label: 'Owner Name', value: 'ownerName' },
  // { label: 'Portal Name', value: 'tenantName' },
  { label: 'Bonus Type', value: 'bonusType' },
  { label: 'Valid Till', value: 'validTo' },
  { label: 'Is Expired', value: 'isExpired' },
  { label: 'Is Claimed', value: 'isClaimed' },
  { label: 'Status', value: 'isActive' },
  { label: 'Action', value: 'superAdminUserId' }
]
